import ButtonPrimary from "components/Button/IPIButtonPrimary";
import React, { FC, ReactNode } from "react";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHeroVisiMisi: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  return (
    <div
      className={`nc-SectionHero relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="w-screen max-w-full space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            {heading}
          </h2>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            {subHeading}
          </span>
         <strong>VISI</strong>
         <p>Menjadi pelopor dalam pengembangan komunitas Ibu yang menjadikan pendidikan sebagai nilai dan bekal utama pengembangan diri dalam pengasuhan.</p>
         <div></div>
         <strong>MISI</strong>
          <p>
            <ul>
              <li> ○ Memberikan edukasi dan pelayanan terbaik dengan mengedepankan prinsip kerjasama yang saling menguntungkan</li>
              <li> ○ Membuka kesempatan kepada setiap Ibu untuk memiliki kemerdekaan dalam pengembangan diri</li>
              <li> ○ Menjadikan kebiasaan belajar,bersosialisasi dan memanfaatkan komunitas sebagai media saling berbagi ilmu</li>    
            </ul>
          </p>
           {!!btnText && <ButtonPrimary href="/login">{btnText}</ButtonPrimary>}
        </div>
      </div>
    </div>
  );
};

export default SectionHeroVisiMisi;
